<template>
  <BaseModal ref="base" name="perfilUsuarioModal" :centered="true" closable>
    <template #title>
      {{ tituloModal }}
    </template>
    <template #body>
      <div class="campos-lista">
        <div v-for="campo in campos" :key="campo.titulo" class="campo-linha">
          <span class="campo-label">{{ campo.titulo }}</span>
          <span
            v-if="campo.tipo === 'booleano'"
            :class="['booleano-icon-wrap', campo.valor ? 'booleano-true' : 'booleano-false']"
          >
            <i :class="campo.valor ? 'bi bi-check-circle-fill' : 'bi bi-x-circle-fill'" />
          </span>
          <span v-else class="campo-valor">{{ campo.valor }}</span>
        </div>
      </div>
    </template>
    <template #footer>
      <button type="button" class="btn btn-secondary" @click="hide">
        <i class="bi bi-x" /> {{ $t('cancelar') }}
      </button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/modules/core/components/BaseModal.vue';

export default {
  components: { BaseModal },
  data: () => ({
    perfilUsuario: null,
  }),
  computed: {
    tituloModal() {
      if (!this.perfilUsuario?.nome) return this.$t('perfil');
      return `${this.$t('perfil')}: ${this.perfilUsuario.nome}`;
    },
    campos() {
      if (!this.perfilUsuario) return [];

      return [
        { titulo: 'Nome', valor: this.formatarValor(this.perfilUsuario.nome) },
        this.campoBooleano('Administrador', this.perfilUsuario.administrador),
        this.campoBooleano('Master', this.perfilUsuario.master),
        this.campoBooleano('Pode cadastrar cliente', this.perfilUsuario.podeCadastrarCliente),
        this.campoBooleano('Pode apertar botao ferramentas', this.perfilUsuario.podeApertarBotaoFerramentas),
        this.campoBooleano('Pode apertar botao nova OS', this.perfilUsuario.podeApertarBotaoNovaOS),
        this.campoBooleano('Pode cancelar OS nao concluida', this.perfilUsuario.podeCancelarOSNaoConcluida),
        this.campoBooleano(
          'Pode dispensar cobranca do valor do produto na OS',
          this.perfilUsuario.podeDispensarCobrancaDoValorDoProdutoNaOS,
        ),
        this.campoBooleano('Pode excluir pagamento', this.perfilUsuario.podeExcluirPagamento),
        this.campoBooleano('Pode finalizar OS', this.perfilUsuario.podeFinalizarOS),
        this.campoBooleano('Pode editar OS', this.perfilUsuario.podeEditarOS),
        this.campoBooleano('Acessa todas OSs', this.perfilUsuario.acessaTodasOSs),
        this.campoBooleano(
          'Pode alterar preco do servico para maior',
          this.perfilUsuario.podeAlterarPrecoDoServicoParaMaior,
        ),
        this.campoBooleano(
          'Pode alterar preco do servico para menor',
          this.perfilUsuario.podeAlterarPrecoDoServicoParaMenor,
        ),
        this.campoBooleano(
          'Pode alterar preco do produto para maior',
          this.perfilUsuario.podeAlterarPrecoDoProdutoParaMaior,
        ),
        this.campoBooleano(
          'Pode alterar preco do produto para menor',
          this.perfilUsuario.podeAlterarPrecoDoProdutoParaMenor,
        ),
        {
          titulo: 'Percentual desconto maximo servico',
          valor: this.formatarNumero(this.perfilUsuario.percentualDeDescontoMaximoServico),
        },
        {
          titulo: 'Percentual desconto maximo produto',
          valor: this.formatarNumero(this.perfilUsuario.percentualDeDescontoMaximoProduto),
        },
        {
          titulo: 'Valor minimo para soma servicos',
          valor: this.formatarNumero(this.perfilUsuario.valorMinimoParaSomaServicos),
        },
      ];
    },
  },
  methods: {
    campoBooleano(titulo, valor) {
      return {
        titulo,
        tipo: 'booleano',
        valor: !!valor,
      };
    },
    show(perfilUsuario) {
      this.perfilUsuario = perfilUsuario;
      this.$refs.base.show();
    },
    hide() {
      this.$refs.base.hide();
    },
    formatarNumero(valor) {
      if (valor == null || valor === '') return '-';
      return Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatarValor(valor) {
      if (valor == null || valor === '') return '-';
      return valor;
    },
  },
};
</script>

<style scoped>

:deep(.modal-content) {

  background-color: #212529;

  border: 1px solid #343a40;

  color: #ffffff;

  font-size: 0.8125rem;

}

:deep(.modal-header) {

  background-color: #1f242a;

  border-bottom: 1px solid #343a40;

  padding: 0.65rem 1rem;

}

:deep(.modal-footer) {

  background-color: #1f242a;

  border-top: 1px solid #343a40;

  padding: 0.5rem 1rem;

}

:deep(.modal-title) {

  color: #ced4da;

  font-size: 0.9rem;

  font-weight: 600;

}

:deep(.modal-body) {

  padding: 0;

}

:deep(.btn-close) {

  filter: invert(1) grayscale(100%);

}

.campos-lista {

  font-size: 0.8125rem;

}

.campo-linha {

  display: flex;

  align-items: center;

  justify-content: space-between;

  padding: 0.4rem 1rem;

  border-bottom: 1px solid #343a40;

}

.campo-linha:last-child {

  border-bottom: none;

}

.campo-linha:nth-child(odd) {

  background-color: #212529;

}

.campo-linha:nth-child(even) {

  background-color: #2a3036;

}

.campo-label {

  color: #ced4da;

  flex: 1;

  padding-right: 1.5rem;

}

.campo-valor {

  color: #ffffff;

  font-weight: 500;

  text-align: right;

  white-space: nowrap;

}

.booleano-icon-wrap {

  display: inline-flex;

  align-items: center;

  justify-content: center;

  width: 1.6rem;

  height: 1.6rem;

  border-radius: 999px;

  border: 1px solid transparent;

  font-size: 0.9rem;

  flex-shrink: 0;

}

.booleano-true {

  color: #d1e7dd;

  background: rgba(25, 135, 84, 0.35);

  border-color: rgba(25, 135, 84, 0.65);

}

.booleano-false {

  color: #f8d7da;

  background: rgba(220, 53, 69, 0.35);

  border-color: rgba(220, 53, 69, 0.65);

}

</style>
